import React, { forwardRef, useState, useEffect } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grow,
  IconButton,
  Typography,
} from '@mui/material'
import { motion } from 'framer-motion'
import { useModal } from 'components/modals'
import { Close } from '@mui/icons-material'
import { callZapier } from 'utils/zapier/callZapier'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function RothSimple({
  onClose,
  title = 'The PARCO team is here to help!',
  content = 'Schedule a meeting and one of our teammates will walk you through the process.',
  buttonText = 'Schedule Appointment',
  buttonColor = '#2370ED',
  buttonHoverColor = '#1c59bd',
  cancelButtonText = '',
  showAction = true,
  actionOverride,
  intakeState,
}) {
  const { openModal } = useModal()
  const scheduleRothClick = () => {
    callZapier({
      user: intakeState,
      hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/u2eay59/',
      payload: {
        user: {
          firstName: intakeState?.firstName,
          lastName: intakeState?.lastName,
          phoneNumber: intakeState?.phone,
          email: intakeState?.email,
        },
      },
      sendNotification: false,
    })
    onClose()
    setTimeout(() => openModal('scheduleAppointment'), 0)
  }
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{ sx: { overflow: 'visible' } }}
    >
      <DialogContent sx={{ overflow: 'visible' }}>
        <motion.div
          key="scheduler"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <Box
            sx={{
              justifyContent: 'space-between',
              position: 'relative',
              top: -64,
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                position: 'absolute',
                top: 0,
                right: -16,
                color: '#fff',
                zIndex: 1,
                backgroundColor: '#000',
                '&:hover': {
                  backgroundColor: '#000',
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Box p={3}>
            <Box>
              <Typography variant="headerTitle" sx={{ color: '#262627' }}>
                {title}
              </Typography>
            </Box>
            <Typography variant="body1" mt={3}>
              {content}
            </Typography>
            <Box
              display="flex"
              justifyContent="space-between"
              mt={3}
              gap={2}
              flexDirection={isMobile ? 'column-reverse' : 'row'}
            >
              <Button
                rel="noreferrer"
                onClick={onClose}
                variant="parcoRounded"
                color="outline"
              >
                {cancelButtonText !== ''
                  ? cancelButtonText
                  : showAction
                  ? 'Cancel'
                  : 'Close'}
              </Button>
              {showAction && (
                <Button
                  rel="noreferrer"
                  onClick={actionOverride ? actionOverride : scheduleRothClick}
                  variant="parcoRounded"
                >
                  {buttonText}
                </Button>
              )}
            </Box>
          </Box>
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
